import { render } from "./TituloDuplo.vue?vue&type=template&id=3020e4b0&scoped=true"
import script from "./TituloDuplo.vue?vue&type=script&lang=js"
export * from "./TituloDuplo.vue?vue&type=script&lang=js"

import "./TituloDuplo.vue?vue&type=style&index=0&id=3020e4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3020e4b0"]])

export default __exports__